<template>
  <div class="test-container">
    <div :v-if="errorMsg">{{ errorMsg }}</div>
    <component :is="loadedComponent" class="tab"></component>
  </div>
</template>

<script>
import DefaultTestComponent from '@/modules/tests/components/DefaultTestComponent'
export default {
  name: 'VueTestsPage',
  components: {
    DefaultTestComponent
  },
  data() {
    return {
      error: null,
      loadedComponent: DefaultTestComponent
    }
  },
  watch: {},
  mounted() {
    if (this.$route.query.component) {
      this.loadComponent(this.$route.query.component)
    }
  },

  computed: {
    errorMsg() {
      if (this.error) {
        return this.error.toString()
      }
      return null
    },
    pageTitle() {
      return this.$t(this.$route.meta.title)
    }
  },

  methods: {
    loadComponent(component) {
      let regexp = /^(common\/tests\/[a-zA-Z-]+)|(modules\/[a-zA-Z-]+\/tests\/[a-zA-Z-]+)$/
      if (component.match(regexp)) {
        import(`@/${component}Test`)
          .then(loadedComponent => {
            this.loadedComponent = loadedComponent.default
          })
          .catch(err => (this.error = err))
      } else {
        this.loadedComponent = DefaultTestComponent
      }
    }
  }
}
</script>

<style scoped>
.test-container {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/modules/tests/pages/VueTestsPage.vue